export default __webpack_public_path__ + "static/media/29-min.db3a0483.jpg";